import { Row, Col } from "reactstrap";
import PanCardIcon from "../../assets/PanCardIcon";
import AddressIcon from "../../assets/AddressIcon";
import BussinessIcon from "../../assets/BussinessIcon";
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import './index.scss'

const ValidateInfomation = () => {
  return (
    <section className="validateInfo">
      <Row>
        <Col md={8}>
          <h2>
            Make sure you have the following documents handy while applying
          </h2>
          <Row>
            <Col md={12}>
              <Row className="iconOutContainer">
                <p>
                  <AddressIcon />
                  Valid address and ID proof
                </p>
              </Row>
              <h5>
                (Valid Driving License / Valid Passport / Aadhar Card)
              </h5>
              <Row className="iconOutContainer">
                <p>
                  <BussinessIcon />
                  Business Registration Proof
                </p>
              </Row>
              <h5>
                (GST Certificate / Udyog AADHAAR / Udyam / Gumasta / Others)
              </h5>
              <Row className="iconOutContainer">
                <p>
                  <PanCardIcon />
                  PAN Card
                </p>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col md={4} className="validationImg">
          <img src="7-01.png" className="banner_img" />
        </Col>
      </Row>
    </section>
  )
}

export default ValidateInfomation;